// extracted by mini-css-extract-plugin
export default {"comment":"_5af916fedddfdf2f","red":"_9184639c6193f6b7","commentText":"a8f89a606a50d77c","button":"_5b7b79046b9df82a"};